import styled from 'styled-components';
import { ButtonBase } from './ButtonBase';

export const DefaultButton = styled(ButtonBase)`
    background: #43B1DB;
    color: #fff;
`